import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LayoutService } from './layout.service';
import { LabelType } from '../models/label-type';

@Injectable({
  providedIn: 'root',
})
export class LabelService {
  private activeLableType: LabelType | null = null;
  private labelMap = new Map<number, string | null>();
  private labelMapSubject = new BehaviorSubject<Map<number, string | null>>(
    new Map()
  );
  public labels$ = this.labelMapSubject.asObservable();
  productDOSMap: Map<number, number> = new Map<number, number>();
  productCapacityMap: Map<number, number> = new Map<number, number>();

  constructor(private layoutService: LayoutService) {
    this.updateLabels();

    this.layoutService.layoutDOS$.subscribe((map) => {
      this.productDOSMap = map;
      if (this.activeLableType) this.updateLabels();
    });

    this.layoutService.layoutCapacity$.subscribe((map) => {
      this.productCapacityMap = map;
      if (this.activeLableType) this.updateLabels();
    });

    this.layoutService.productsChanged$.subscribe(() => {
      if (this.activeLableType) this.updateLabels();
    });
  }

  private updateLabels() {
    this.layoutService.planogramItems.forEach((productRef) => {
      if (this.activeLableType === LabelType.BARCODE) {
        this.labelMap.set(productRef.productId, productRef.barcode);
      } else if (this.activeLableType === LabelType.BRAND) {
        this.labelMap.set(productRef.productId, productRef.brand);
      } else if (this.activeLableType === LabelType.FLOW) {
        this.labelMap.set(productRef.productId, `${productRef.categoryFlow}`);
      } else if (this.activeLableType === LabelType.UOS) {
        this.labelMap.set(
          productRef.productId,
          `${productRef.uos} ${productRef.unit}`
        );
      } else if (this.activeLableType === LabelType.DOS) {
        let totalDOS = this.productDOSMap.get(productRef.productId) ?? 0;
        this.labelMap.set(
          productRef.productId,
          `${totalDOS.toFixed(1)}`
        );
      } else if (this.activeLableType === LabelType.SALE_QTY) {
        this.labelMap.set(
          productRef.productId,
          `${productRef.salesData.salesQty.toFixed(1)}`
        );
      } else if (this.activeLableType === LabelType.SALES) {
        this.labelMap.set(
          productRef.productId,
          `R ${productRef.salesData.sales.toFixed(1)}`
        );
      } else if (this.activeLableType === LabelType.AVG_PRICE) {
        this.labelMap.set(
          productRef.productId,
          `R ${productRef.salesData.averagePrice.toFixed(1)}`
        );
      } else if (this.activeLableType === LabelType.DESC) {
        this.labelMap.set(productRef.productId, `${productRef.description}`);
      } else if (this.activeLableType === LabelType.DESC1) {
        this.labelMap.set(
          productRef.productId,
          `${productRef.labels.description1 ?? 'n/a'}`
        );
      } else if (this.activeLableType === LabelType.DESC2) {
        this.labelMap.set(
          productRef.productId,
          `${productRef.labels.description2 ?? 'n/a'}`
        );
      } else if (this.activeLableType === LabelType.DESC3) {
        this.labelMap.set(
          productRef.productId,
          `${productRef.labels.description3 ?? 'n/a'}`
        );
      } else if (this.activeLableType === LabelType.DESC4) {
        this.labelMap.set(
          productRef.productId,
          `${productRef.labels.description4 ?? 'n/a'}`
        );
      } else if (this.activeLableType === LabelType.DESC5) {
        this.labelMap.set(
          productRef.productId,
          `${productRef.labels.description5 ?? 'n/a'}`
        );
      } else if (this.activeLableType === LabelType.VAL1) {
        this.labelMap.set(
          productRef.productId,
          `${productRef.labels.value1 ?? 'n/a'}`
        );
      } else if (this.activeLableType === LabelType.VAL2) {
        this.labelMap.set(
          productRef.productId,
          `${productRef.labels.value2 ?? 'n/a'}`
        );
      } else if (this.activeLableType === LabelType.VAL3) {
        this.labelMap.set(
          productRef.productId,
          `${productRef.labels.value3 ?? 'n/a'}`
        );
      } else if (this.activeLableType === LabelType.VAL4) {
        this.labelMap.set(
          productRef.productId,
          `${productRef.labels.value4 ?? 'n/a'}`
        );
      } else if (this.activeLableType === LabelType.VAL5) {
        this.labelMap.set(
          productRef.productId,
          `${productRef.labels.value5 ?? 'n/a'}`
        );
      } else if (this.activeLableType === LabelType.CAPACITY_CASEPACK) {
        const capacity = this.productCapacityMap.get(productRef.productId) ?? 0;
        this.labelMap.set(
          productRef.productId,
          `${capacity}/${productRef.casePack ?? '-'}`
        );
      } else {
        this.labelMap.set(productRef.productId, null);
      }
    });
    this.labelMapSubject.next(this.labelMap);
  }

  currentLabelType() {
    return this.activeLableType;
  }

  showLabels(labelType: LabelType) {
    this.activeLableType = labelType;
    this.updateLabels();
  }

  hideLabels() {
    this.activeLableType = null;
    this.labelMapSubject.next(new Map());
  }
}
